import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Icon from "sap/ui/core/Icon";

export type StatusConfigEntry = { path: string, color: string }

export const renderer = {
  apiVersion: 4,
  render: (rm: RenderManager, control: StatusIcon<string>) => {
    rm.renderControl(control.getAggregation("_icon") as Control);
  },
}

/**
 * @namespace vamos.cockpit.base.control
 */
export default abstract class StatusIcon<Type extends string> extends Control {

  protected abstract statusConfig: Record<Type, StatusConfigEntry>

  static readonly metadata: MetadataOptions = {
    properties: {
      status: {
        type: "any",
        defaultValue: "",
      },
    },
    aggregations: {
      _icon: {
        type: "sap.ui.core.Icon",
        multiple: false,
        visibility: "hidden",
      },
    },
  };

  private _resolveStatus(status: Type): void {
    const config = this.statusConfig[status];
    if(!config) {
      return;
    }

    const icon: Icon = this.getAggregation("_icon") as Icon;

    icon.setSrc(config.path);
    icon.setColor(config.color);
  }

  public setStatus(status: Type) {
    this.setProperty("status", status, false);
    this._resolveStatus(status);
  }

  init(): void {
    this.setAggregation("_icon", new Icon());
  }

  // musst be defined in derived class aswell

  public static renderer = renderer;
};